import React, { useState, useEffect, useCallback } from 'react';
import { useReview } from '../context/ReviewContext';
import { useClipboard } from '../hooks/useClipboard';
import { StarRating } from '../components/StarRating';
import '../styles/ReviewForm.css';
import { useParams } from 'react-router-dom';

const ReviewForm = () => {
  const { sub } = useParams(); 
  
  // Add this debug log at the top of your component
  console.log('ReviewForm component rendered, sub value:', sub);
  
  const [firstname, setName] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');   
  const [reviewText, setReviewText] = useState('');
  const [phone, setPhone] = useState('');
  const [placeId, setPlaceId] = useState(''); 
  const { currentRating, setRating, addReview } = useReview();
  const { copyToClipboard } = useClipboard();

  // Function to fetch place ID from user collection
  const fetchPlaceId = useCallback(async () => {
    console.log('fetchPlaceId function called with sub:', sub); // Debug log
    
    try {
      const response = await fetch(`/api/user/${sub}/place-id`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('Response status:', response.status); // Debug log

      if (response.ok) {
        const data = await response.json();
        console.log('Response data:', data); // Debug log
        setPlaceId(data.placeId);
      } else {
        console.error('Failed to fetch place ID');
      }
    } catch (error) {
      console.error('Error fetching place ID:', error);
    }
  }, [sub]);

  // Single useEffect to fetch place ID when component mounts
  useEffect(() => {
    console.log('useEffect triggered, sub value:', sub); // Debug log
    if (sub) {
      console.log('Calling fetchPlaceId...'); // Debug log
      fetchPlaceId();
    } else {
      console.log('No sub value, skipping fetchPlaceId'); // Debug log
    }
  }, [sub, fetchPlaceId]);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
    
  //   if (!name.trim() || !reviewText.trim() || !currentRating) {
  //     alert('Please fill in all fields');
  //     return;
  //   }

  //   addReview({
  //     name: name.trim(),
  //     text: reviewText.trim(),
  //     rating: currentRating
  //   });

  //   // Reset form
  //   setName('');
  //   setReviewText('');
  //   setRating(0);
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!firstname.trim() || !email.trim() || !phone) {
      alert('Please fill in all fields');
      return;
    }

    // Create review object
    const reviewData = {
      name: firstname.trim() +' '+lastname.trim(),
      email: email.trim(),
      rating: currentRating,
      review: reviewText.trim(),
      phone: phone.trim(),
      sub: sub
    };

    try {
      // Save to backend database
      const response = await fetch('/api/submit_details', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reviewData)
      });

      if (response.ok) {
        // Success - add to local context
        addReview(reviewData);
        
        // Reset form
        setName('');
        setReviewText('');
        setRating(0);
        setLastname(''); 
        setEmail('');  
        setPhone('');  

        // Show success message
       // alert('Review submitted successfully!');
        
        // Automatically redirect to Google Reviews after successful submission
        await redirectToGoogleReviews(reviewData);
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message || 'Failed to submit review'}`);
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      alert('Failed to submit review. Please try again.');
    }
  };

  // New function to handle Google Reviews redirect
  const redirectToGoogleReviews = async (reviewData) => {
    const formattedReview = formatReviewForGoogle({
      name: reviewData.name,
      text: reviewData.review,
      rating: reviewData.rating
    });

    const result = await copyToClipboard(formattedReview);
    
    if (result.success) {
      // Open Google review page
     // const placeId = 'ChIJjZL8Qr5bpjsRXkvg5D_c504';
      const googleReviewUrl = `https://search.google.com/local/writereview?placeid=${placeId}`;
      window.open(googleReviewUrl, '_blank');
    } else {
      alert(result.message);
    }
  };

  const formatReviewForGoogle = (review) => {
    const stars = '⭐'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
    return `${review.text}`;
  };

  return (
    <div className="review-form">
      <h2>Write a Review</h2>
      
      <form onSubmit={handleSubmit}>
        {/* <div className="form-group">
          <label htmlFor="firstname">Your Name</label>
          <input
            type="text"
            id="firstname"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter your name"
            required
          />
        </div> */}
   <div className="form-group">
          <label htmlFor="firstname">First Name</label>
          <input
            type="text"
            id="firstname"
            value={firstname}
            onChange={(e) => setName(e.target.value)}
            placeholder="First Name"
            required
          />
        </div>
           <div className="form-group">
          <label htmlFor="lastname">Last Name</label>
          <input
            type="text"
            id="lastname"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
            placeholder="Last Name"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="text"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
          />
        </div>
          <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input
            type="text"
            id="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Phone"
            required
          />
        </div>
        {/* <div className="form-group">
          <label>Rating</label>
          <StarRating
            rating={currentRating}
            onRatingChange={setRating}
          />
        </div> */}

        {/* <div className="form-group">
          <label htmlFor="review">Your Review</label>
          <textarea
            id="review"
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
            placeholder="Share your experience with us..."
            rows="5"
            maxLength="500"
            required
          />
          <div className="char-count">
            {reviewText.length}/500 characters
          </div>
        </div> */}

        <button type="submit" className="submit-btn">Ok
          {/* <i className="fas fa-paper-plane"></i>Ok */}
        </button>
      </form>

      {/* <div className="google-review-section">
        <h3><i className="fab fa-google"></i> Post to Google Reviews</h3>
        <p>Share your review on Google Reviews</p>
        
        <button
          type="button"
          onClick={handlePostToGoogle}
          className="google-btn primary"
        >
          <i className="fab fa-google"></i> Post to Google Reviews
        </button>
      </div> */}
      {/* <div className="reviews-section">
        <h2>Recent Reviews</h2>
        <div id="reviewsList" className="reviews-listed">
        </div>
      </div> */}
    </div>
      
  );
};
export default ReviewForm;